import { render } from "./StatsAndFinanceCard.vue?vue&type=template&id=76228784"
import script from "./StatsAndFinanceCard.vue?vue&type=script&lang=js"
export * from "./StatsAndFinanceCard.vue?vue&type=script&lang=js"

import "./StatsAndFinanceCard.vue?vue&type=style&index=0&id=76228784&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__